import React from 'react';
import { PLATFORM_CONFIG } from 'utils/accessManager/constants';
import useUser from 'utils/useUser';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const MenuItemPlatform = ({ onClick }) => {
  const { platformMode } = useUser();
  const history = useHistory();

  const {
    user: { switchPlatformMode },
  } = useDispatch();

  const togglePlatformMode = () => {
    const newMode = switchPlatformMode({});
    history.push(PLATFORM_CONFIG[newMode].dashboard);
  };

  const clickHandler = () => {
    togglePlatformMode();
    onClick();
  };

  return (
    <button className="menu-item-icon" onClick={clickHandler}>
      <div className="menu-item-icon__icon">
        {PLATFORM_CONFIG[platformMode].icon}
      </div>
      <div className="menu-item-icon__text">
        {PLATFORM_CONFIG[platformMode].switch}
      </div>
    </button>
  );
};

MenuItemPlatform.defaultProps = {
  onClick: () => {},
};

MenuItemPlatform.propTypes = {
  onClick: PropTypes.func,
};

export default MenuItemPlatform;
